import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { SearchService } from 'app/search/search.service';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { AccountSearchSummary } from '../../model/accountsearchsummary';

@Component({
  selector: 'account-search',
  templateUrl: './account-search.component.html',
  styleUrls: ['./account-search.component.scss']
})
export class AccountSearchComponent implements OnInit {

  @Input() resource: string;

  constructor(private serivce: SearchService,
    private formBuilder: FormBuilder,private router: Router,private route: ActivatedRoute) { }


    /** String holding query for account /account nubmer */

  query = new FormControl('');
  @Output() accountDetailEvent =  new EventEmitter<any>();

  
  searchForm: FormGroup;

  ngOnInit(): void {
    this.createSearchForm();
  }

  
  search(){
    const savingsAccountSummary$ = this.serivce.getSearchResults<AccountSearchSummary[]>(this.query.value,this.resource);
    
    savingsAccountSummary$.subscribe((res: AccountSearchSummary[]) => {
      this.query.markAllAsTouched();
      this.query.setErrors({ invalid: (<Array<any>><unknown>res).length === 0 });
      this.accountDetailEvent.emit(res);
     
    });
    
    //this.serivce.getSavingsTransactionTemplateResource();

  }

  private createSearchForm() {
    this.searchForm = this.formBuilder.group({
      'query': ['',Validators.required],
    });
  }
}
